import { SEND_COMMAND_FAILURE, SEND_COMMAND_REQUEST, SEND_COMMAND_SUCCESS } from '../internal/action-types';
export var sendCommandRequest = function sendCommandRequest(command, usedByHook) {
  return {
    type: SEND_COMMAND_REQUEST,
    command: command,
    usedByHook: usedByHook
  };
};
export var sendCommandSuccess = function sendCommandSuccess(command, result) {
  return {
    type: SEND_COMMAND_SUCCESS,
    command: command,
    result: result
  };
};
export var sendCommandFailure = function sendCommandFailure(command, error) {
  return {
    type: SEND_COMMAND_FAILURE,
    command: command,
    error: error
  };
};
//# sourceMappingURL=actions.js.map